import React from "react";
import { Edit as RaEdit, NumberField, required, SimpleForm } from "react-admin";
import InvoiceInput from "./inputs/InvoiceInput";
import Toolbar from "./Toolbar";

const Edit = (props) => (
	<RaEdit {...props} mutationMode="pessimistic">
		<SimpleForm toolbar={<Toolbar />}>
			<NumberField
				source="amount"
				options={{ style: "currency", currency: "EUR" }}
			/>
			<InvoiceInput source="invoice" validate={required()} />
		</SimpleForm>
	</RaEdit>
);
export default Edit;
